import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import BurgerMenu from '../../../elements/BurgerMenu';
import event from '../../../../utils/analytics/event';
import { MenuContainer, Menu, MenuSubscribeButton, MenuLink, LinksContainer, ExternalMenuLink, Overlay } from './MobileNavBar.styles';

var MobileNavBar = function MobileNavBar(_ref) {
  var links = _ref.links,
      menuColor = _ref.menuColor,
      menuIconColor = _ref.menuIconColor,
      menuItemColor = _ref.menuItemColor,
      menuDividerColor = _ref.menuDividerColor,
      mobileHoverState = _ref.mobileHoverState,
      piwikEvents = _ref.piwikEvents,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? 'Subscribe' : _ref$buttonText;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var history = useHistory();
  var location = useLocation();
  var pathname = location.pathname;
  var showSubscribe = pathname !== "/";

  var itemOnClick = function itemOnClick(link) {
    if (link.onClick) {
      link.onClick();
    }
  };

  return /*#__PURE__*/React.createElement(MenuContainer, null, /*#__PURE__*/React.createElement(BurgerMenu, {
    open: open,
    handleClick: function handleClick() {
      setOpen(!open);
      event(piwikEvents ? piwikEvents.menuToggle : ['click', 'toggle-nav']);
    },
    color: menuIconColor || 'gray'
  }), /*#__PURE__*/React.createElement(Menu, {
    open: open,
    menuColor: menuColor
  }, /*#__PURE__*/React.createElement(LinksContainer, null, links.map(function (link) {
    var selected = pathname === link.to;
    return link.external ? /*#__PURE__*/React.createElement(ExternalMenuLink, {
      selected: selected,
      onClick: function onClick() {
        setOpen(false);
        event(piwikEvents ? piwikEvents.navItemClick : ['click', 'nav-item', link.title]);
        itemOnClick(link);
      },
      key: link.title,
      href: link.to,
      target: "_blank",
      menuDividerColor: menuDividerColor,
      mobileHoverState: mobileHoverState,
      menuItemColor: menuItemColor
    }, link.title) : /*#__PURE__*/React.createElement(MenuLink, {
      selected: selected,
      onClick: function onClick() {
        setOpen(false);
        event(piwikEvents ? piwikEvents.navItemClick : ['click', 'nav-item', link.title]);
        itemOnClick(link);
      },
      key: link.title,
      to: link.to,
      menuDividerColor: menuDividerColor,
      mobileHoverState: mobileHoverState,
      menuItemColor: menuItemColor
    }, link.title);
  })), showSubscribe && /*#__PURE__*/React.createElement(MenuSubscribeButton, {
    onClick: function onClick() {
      history.push("/");
      setOpen(false);
    }
  }, buttonText)), open && /*#__PURE__*/React.createElement(Overlay, {
    onClick: function onClick() {
      return setOpen(false);
    }
  }));
};

MobileNavBar.propTypes = {
  links: PropTypes.array.isRequired,
  menuColor: PropTypes.string,
  menuItemColor: PropTypes.string,
  menuDividerColor: PropTypes.string,
  menuIconColor: PropTypes.string,
  mobileHoverState: PropTypes.object,
  piwikEvents: PropTypes.object,
  buttonText: PropTypes.string
};
MobileNavBar.defaultProps = {
  buttonText: 'Subscribe'
};
export default MobileNavBar;